import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import TableContent from "../../table/table";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  AddTakadeAction,
  AddTypedawaAction,
  DeleteTakadedegAction,
  GetTakadeAction,
  GetTypedawaAction,
  UpdateTakadedegAction,
} from "../../../../redux/actions/CourtAction";
import { ToastContainer } from "react-toastify";
const Degreetakade = () => {
  const [TakadeDegree, setTakadeDegree] = useState("");
  const [Note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [IdTakade, setIdTakade] = useState("");
  const [Eye, setEye] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIdTakade(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteTakadedegAction(IdTakade));
    setLoading(false);
    setIdTakade("");
    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.CourtR.DegreeTaqade);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetTakadeAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (TakadeDegree === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      AddTakadeAction({
        Level: TakadeDegree,
        Note: Note,
      })
    );
    setTakadeDegree("");
    setNote("");
    setIdTakade("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (TakadeDegree === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateTakadedegAction({
        Id: IdTakade,
        Level: TakadeDegree,
        Note: Note,
      })
    );
    setTakadeDegree("");
    setNote("");
    setIdTakade("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };
  const Update = (item) => {
    setTakadeDegree(item.Level);
    setNote(item.Note);
    setIdTakade(item.Id);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setTakadeDegree(item.Level);
    setNote(item.Note);
    setIdTakade(item.Id);
    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.CourtR.AddDegreeTaqade);
  const UP = useSelector((state) => state.CourtR.UpdateDegreeTaqade);
  const DEL = useSelector((state) => state.CourtR.DeleteDegreeTaqade);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage ===
              "Great, level of lawsuit created Successfully"
          ) {
            dispatch(GetTakadeAction());
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.data.StatusCode === 200 || UP.data.StatusCode === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage ===
              "Great, levelOfLawsuit updated Successfully"
          ) {
            dispatch(GetTakadeAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.StatusCode !== 200 || UP.StatusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage ===
              "Great, Level Of Law Suit deleted Successfully"
          ) {
            dispatch(GetTakadeAction());
            notify("تم حذف درجة التقاضي بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Can't delete it because you are using it"
          ) {
            notify("لا يمكن حذف درجة التقاضي لانها مستخدمة", "warn");
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                value={TakadeDegree}
                onChange={(e) => setTakadeDegree(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    درجة التقاضي
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="الوصف"
                variant="outlined"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        {/* <TableContent
          tablecontent={[
            { name: "", icon: <i className="fa-solid fa-hashtag"></i> },
            {
              name: "نوع الدعوى",
              icon: <i className="fa-solid fa-calendar-days"></i>,     
            },
            { name: "الوصف", icon: <i className="fa-solid fa-user"></i> },
            {
              name: "",
            },
            {
              name: "",
            },
            {
              name: "",
            },
          ]}
          data={[9, 10, 11]}
        /> */}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                درجة التقاضي<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوصف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(ALL) && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.Id}>
                    <td>{item.Level}</td>
                    <td>{item.Note}</td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.Id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      <ToastContainer autoClose={1200} />
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Degreetakade;
